<app-draggable-modal-wrapper>
    <h2
        mat-dialog-title
        modal-drag-handle
        class="!text-2xl !font-normal !text-primary-700 !mb-2"
    >
        Safe Harbor Results
    </h2>
    <hr />
    <mat-dialog-content class="mat-typography">
        @if (passed()) {
            <h3 class="text-sm">Safe Harbor check passed.</h3>
        } @else {
            <h3 class="text-sm">The following failed the Safe Harbor check.</h3>
            <ag-grid-angular
                [rowData]="rowData[gridTypes.maximumErpExceeded]"
                [gridOptions]="maximumErpExceededGridOptions"
                (gridReady)="onGridReady($event, gridTypes.maximumErpExceeded)"
                class="ag-theme-quartz h-[270px] w-full"
            >
            </ag-grid-angular>
        }
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="!p-5">
        <button
            mat-raised-button
            mat-dialog-close
            type="button"
            name="Save"
            cdkFocusInitial
            color="primary"
        >
            Acknowledge
        </button>
    </mat-dialog-actions>
</app-draggable-modal-wrapper>
